import styled from 'styled-components';
import RTKDesc from '../../../assets/images/pluvaAutoLanding/RTK-GPS_desc.png';
import RTKObject from '../../../assets/images/pluvaAutoLanding/RTK-GPS_object.jpg';
import { Icon } from '../../../components/common/icon/Icon';
import { PointBadge } from './PointBadge';

export const RTKGPSSection = () => {
  return (
    <Container>
      <TitleSection>
        <PointBadge title={'유료 RTK-GPS'} />
        <Title>{'유료 RTK-GPS를 이용한\n초정밀 자율주행!'}</Title>
        <SubTitle>{'24년 구매 고객 대상 5년간\n통신 비용 무상 지원!'}</SubTitle>
        <Image src={RTKObject} />
        <TitleHelperText>{'높은 안정성의 유료 RTK-GPS로\n차원이 다른 자율주행 경험을 제공!'}</TitleHelperText>
      </TitleSection>
      <RTKGPSDescription>
        <RTKGPSDescriptionBox>
          <RTKGPSTitleSection>
            <Icon name={'OrangeExclamationMark'} width={20} height={20} />
            <RTKGPSTitle>{'RTK-GPS란?'}</RTKGPSTitle>
          </RTKGPSTitleSection>
          <RTKGPSImageSection>
            <RTKGPSImage src={RTKDesc} />
            <RTKGPSImageText>
              {'오차범위 '}
              <TextHighlight>{'최대 2.5cm'}</TextHighlight>
            </RTKGPSImageText>
          </RTKGPSImageSection>
          <RTKGPSContent>
            {
              'RTK-GPS는 목적지를 오차범위 2.5cm이내로 안내하는 정밀 측위 기술입니다. 또한 유료 RTK-GPS 서비스는 무료 서비스 대비 높은 신호 안정성을 가지고 있습니다.'
            }
          </RTKGPSContent>
        </RTKGPSDescriptionBox>
      </RTKGPSDescription>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  padding: 48px 24px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 32px;
  align-self: stretch;
`;

const TitleSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: var(--radius-large, 16px);
  align-self: stretch;

  white-space: pre-line;
`;

const Title = styled.h2`
  color: var(--Light-Scheme-Monochrome-black, #232429);
  text-align: center;

  /* Display/XXX-Large/xxxl-bold */
  font-family: Pretendard;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 130%; /* 31.2px */
`;

const SubTitle = styled.h3`
  color: var(--Light-Scheme-Color-primary-green, #34c77e);
  text-align: center;

  /* Display/Large/l-bold */
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 130%; /* 20.8px */
`;

const Image = styled.img`
  width: 180px;
`;

const TitleHelperText = styled.p`
  color: var(--Light-Scheme-Monochrome-black, #232429);
  text-align: center;

  /* Display/Large/l-regular */
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 130%; /* 20.8px */

  white-space: pre-line;
`;

const RTKGPSDescription = styled.div`
  display: flex;
  padding: 24px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: var(--radius-large, 16px);
  align-self: stretch;

  border-radius: var(--radius-medium, 8px);
  background: var(--Light-Scheme-Monochrome-black, #232429);
`;

const RTKGPSDescriptionBox = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 24px;
  align-self: stretch;
`;

const RTKGPSTitleSection = styled.div`
  display: flex;
  align-items: center;
  gap: var(--radius-small, 4px);
  align-self: stretch;
`;

const RTKGPSTitle = styled.h3`
  color: var(--Light-Scheme-Monochrome-white, #fff);

  /* Display/X-Large/xl-bold */
  font-family: Pretendard;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 130%; /* 23.4px */
`;

const RTKGPSImageSection = styled.div`
  display: flex;
  padding: 24px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: var(--radius-medium, 8px);
  align-self: stretch;

  border-radius: var(--radius-medium, 8px);
  background: rgba(255, 255, 255, 0.05);
`;

const RTKGPSContent = styled.p`
  color: var(--Light-Scheme-Monochrome-white, #fff);

  /* Display/Large/l-regular */
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 130%; /* 20.8px */
`;

const RTKGPSImage = styled.img`
  width: 200px;
`;

const RTKGPSImageText = styled.p`
  color: var(--Light-Scheme-Monochrome-white, #fff);
  text-align: center;

  /* Display/Medium/m-medium */
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 130%; /* 18.2px */
`;

const TextHighlight = styled.span`
  color: var(--Light-Scheme-Color-primary-green, #34c77e);
`;
